export default __webpack_public_path__ + "static/media/check_circle_outline.52b7951b.svg";